<template>
  <div>
    <Main
      ref="main"
      :disabled="disabled"
      @close="close"
      @reset="() => $emit('reset')"
      :amzFirstDemandCode="amzFirstDemandCode"
    />
  </div>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    amzFirstDemandCode: { type: String, default: '' },
  },
  data() {
    return {
      notReplenishVisible: false,
    }
  },
  methods: {
    close() {
      if (!this.disabled) this.$emit('reload')
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 10px;
}
.drawer-footer {
  padding: 10px 30px 30px;
  display: flex;
  justify-content: flex-end;
}
</style>
